const Lang = require('lang');
const GlobalAlerts = require('../../../../functions/GlobalAlerts');

/**
 * Inicialização
 */
function Tag() {
  const buttonsRemoveTag = document.querySelectorAll('[data-tag-delete]');

  if (buttonsRemoveTag.length) {
    buttonsRemoveTag.forEach((currentButton) => {
      currentButton.addEventListener('click', handlerClickRemoveTag);
    })
  }
}

/**
 * Manipulador do click de delete TAG
 *
 * Desabilita o botão de delete para impedir clicks duplos e em seguida
 * exibe o modal de confirmação para o delete da tag
 *
 * @param {Event} event
 */
function handlerClickRemoveTag(event) {
  const buttomClicked = event.target;

  buttomClicked.disabled = true;

  return bootbox.confirm({
    title: Lang.get('js/src/app/settings/horus/tag/Tag.title_confirm_delete_tag'),
    message: Lang.get('js/src/app/settings/horus/tag/Tag.message_confirm_delete'),
    buttons: {
      cancel: {
        label: Lang.get('js/common/words.cancel'),
        className: 'btn-default',
      },
      confirm: {
        label: Lang.get('js/common/words.remove'),
        className: 'btn-danger',
      }
    },
    callback: ((result) => callbackConfirmToDeleteTag(result, buttomClicked))
  });
}

/**
 * Callback confirmação deletar tag
 *
 * Caso a confirmação seja realizada, uma request ajax é enviada para
 * a url de delete, que se retornar um sucesso irá remover da tela
 * a row da tag excluída.
 * O botão de delete será reabitado em caso de falha ou de não
 * confirmação do delete
 *
 * @param {boolean} result
 * @param {Element} buttomClicked
 */
function callbackConfirmToDeleteTag(result, buttomClicked) {
  const idTag = buttomClicked.dataset.tagDelete;

  // cancelamento do delete reabilita o botão de delete
  if (!result) {
    buttomClicked.disabled = false;
    return;
  }

  nifty.body.overlay('show');
  $.ajax({
    url: route('app.settings.horus.tags.remover', {idTag: idTag}),
    method: 'DELETE',
  })
  .done((response) => {
    document
      .querySelector(`[data-tag-id="${idTag}"]`)
      .remove();

    GlobalAlerts.createAndShow({
      type: 'success',
      title: Lang.get('js/common/phrases.success'),
      message: response.message
    });
  })
  .fail(() => {
    buttomClicked.disabled = false;
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/common/phrases.ops'),
      message: Lang.get('js/common/phrases.unexpected_error')
    });
  })
  .always(() => nifty.body.overlay('hide'));
}

module.exports = {
  init: Tag,
  url: /^\/settings\/horus\/tags$/,
}
